import { useRef, useState } from "react"
import "./dropdown.component.css"
import useClickOutside from "../../hooks/useClickOutside"
import { chevronDownIcon } from "../../icons"

const DropdownComponent = (props) => {
  const { placeholder, disabled, options, value, onChange } = props
  const [expanded, setExpanded] = useState()
  const expandedRef = useRef()
  useClickOutside(expandedRef, () => setExpanded(false))

  const handleOptionClick = (o) => {
    onChange(o)
    setExpanded(false)
  }

  return (
    <div className={disabled ? "cb-dropdown disabled" : "cb-dropdown"}>
      <button onClick={() => setExpanded(true)}>
        {value ? value.label : placeholder} {chevronDownIcon}
      </button>
      {expanded && (
        <div className="cb-dropdown-expanded" ref={expandedRef}>
          {options.map((o) => {
            return (
              <div
                className="cb-dropdown-option"
                key={o.key}
                onClick={() => handleOptionClick(o)}
              >
                {o.label}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default DropdownComponent
